import { isValidPhoneNumber } from 'libphonenumber-js';
// Minimal type for Zod superRefine ctx to avoid private imports
// Returns a superRefine-compatible function that validates phone presence and format
export const phoneSuperRefine = (
  telKey = 'tel',
  prefixKey = 'telPrefix',
  defaultPrefix = '+66',
  optional = false,
) => {
  return (data: Record<string, unknown>, ctx: unknown) => {
    const raw = data[telKey];
    let telVal = '';
    if (typeof raw === 'string') telVal = raw.trim();
    else if (typeof raw === 'number' || typeof raw === 'boolean')
      telVal = String(raw).trim();

    const prefixRaw = data[prefixKey];
    const telPrefix =
      typeof prefixRaw === 'string' && prefixRaw ? prefixRaw : defaultPrefix;

    interface CtxWithAddIssue {
      addIssue?: (issue: {
        code: string;
        path?: (string | number)[];
        message?: string;
      }) => void;
    }
    const ctxTyped = ctx as CtxWithAddIssue;
    const addIssue = ctxTyped.addIssue;
    if (typeof addIssue !== 'function') return;

    // If optional and no value provided, skip validation
    if (optional && !telVal) {
      return;
    }

    if (!telVal) {
      addIssue({
        code: 'custom',
        path: [telKey],
        message: 'validation.required',
      });
      return;
    }

    const e164 = `${telPrefix}${telVal}`;
    if (!isValidPhoneNumber(e164)) {
      addIssue({
        code: 'custom',
        path: [telKey],
        message: 'validation.invalidPhone',
      });
    }
  };
};

export default phoneSuperRefine;
